var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDatepicker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 0C4.16421 0 4.5 0.335786 4.5 0.75V2H9.5V0.75C9.5 0.335786 9.83579 0 10.25 0C10.6642 0 11 0.335786 11 0.75V2H12.25C13.2165 2 14 2.7835 14 3.75V14.25C14 15.2165 13.2165 16 12.25 16H1.75C0.783501 16 0 15.2165 0 14.25V3.75C0 2.7835 0.783502 2 1.75 2H3V0.75C3 0.335786 3.33579 0 3.75 0ZM12.25 3.5C12.3881 3.5 12.5 3.61193 12.5 3.75V6H1.5V3.75C1.5 3.61193 1.61193 3.5 1.75 3.5H12.25ZM1.5 7.5V14.25C1.5 14.3881 1.61193 14.5 1.75 14.5H12.25C12.3881 14.5 12.5 14.3881 12.5 14.25V7.5H1.5Z",
    fill: "#77787D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDatepicker);
export default __webpack_public_path__ + "static/media/ic-datepicker.9d87702033241c55614f1ea08793cb54.svg";
export { ForwardRef as ReactComponent };